import { FetchClient } from "../utils/fetchClient";

export async function getWarningMessageFromSectionId(sectionId = 0) {
    return await FetchClient(`/data/warning-messages?section_ids=${sectionId}`).GET({})
}

export async function saveWarningMessageService (body){
    return await FetchClient(`/data/warning-messages`).POST({payload: JSON.stringify(body)})
}